import { render } from "./ConfirmModal.vue?vue&type=template&id=4b4c7252&ts=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__